import DollarPieChartIcon from './DollarPieChartIcon'

export default DollarPieChartIcon
